import React from "react";
import CustomInputField from "../../../components/customInputField";
import { useFormik } from "formik";
import { EditProfileSchema } from "../../../utils/validationSchema";
import CustomModal from "../../../components/customModal";
import { useDispatch, useSelector } from "react-redux";
import { editProfile, getProfile } from "../action";

const EditProfileModal = ({ visible, visibleHandler }) => {
  const { adminDetails: profileDetails } = useSelector(
    (state) => state.AuthReducer
  );
  const dispatch = useDispatch();
  const initialValues = {
    firstName: profileDetails?.firstName || "",
    lastName: profileDetails?.lastName || "",
    phoneNo: profileDetails?.phoneNo || "",
  };

  const editProfileData = useFormik({
    initialValues: initialValues,
    validationSchema: EditProfileSchema,
    onSubmit: (values, actions) => {
      dispatch(
        editProfile(values, () => {
          dispatch(getProfile());
        })
      );
      visibleHandler();
    },
  });
  const renderBody = () => {
    return (
      <div className="edit-profile-body-container">
        <div>
          <CustomInputField
            label={"First Name"}
            changeHandler={editProfileData.handleChange}
            placeholderText={"Enter first name"}
            value={editProfileData.values.firstName}
            name={"firstName"}
          />
          {editProfileData.errors.firstName &&
            editProfileData.touched.firstName && (
              <div className="change-password-error">
                {editProfileData.errors.firstName}
              </div>
            )}
        </div>
        <div>
          <CustomInputField
            label={"Last Name"}
            changeHandler={editProfileData.handleChange}
            placeholderText={"Enter last name"}
            value={editProfileData.values.lastName}
            name={"lastName"}
          />
          {editProfileData.errors.lastName &&
            editProfileData.touched.lastName && (
              <div className="change-password-error">
                {editProfileData.errors.lastName}
              </div>
            )}
        </div>
        <div>
          <CustomInputField
            label={"Phone Number"}
            changeHandler={editProfileData.handleChange}
            placeholderText={"Enter mobile number"}
            value={editProfileData.values.phoneNo}
            name={"phoneNo"}
          />
          {editProfileData.errors.phoneNo &&
            editProfileData.touched.phoneNo && (
              <div className="change-password-error">
                {editProfileData.errors.phoneNo}
              </div>
            )}
        </div>
      </div>
    );
  };

  return (
    <CustomModal
      body={renderBody}
      confirmHandler={editProfileData.handleSubmit}
      heading={"Edit Profile"}
      modalSize={"md"}
      visible={visible}
      visibleHandler={visibleHandler}
    />
  );
};

export default EditProfileModal;
